<template>
  <v-footer
    bottom fixed
    width="100%"
    padless
    id="app-footer"
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="py-0.5 text-center"
        cols="12"
      >
        <strong>MoonTomi v3.0</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
  export default {}
</script>
<style scoped>
#app-footer {
  background-color: #242d3c;
  color: aliceblue;
}
</style>